import { useGlobalContainerRef } from '@/wc/helper/ref';
import { IconHelp, Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { SingleRowProps } from '../../type';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

export const SingleRow: FC<SingleRowProps> = ({
  label,
  value,
  renderContent,
  contentClassName = '',
  helperLabel = '',
}) => {
  const content = renderContent ? renderContent : value;
  const hasHelperLabel = !!helperLabel;
  const container = useGlobalContainerRef();
  return (
    <div className={cx('rowDetailContainer')}>
      <div
        className={cx('rowDetailLabel', {
          rowDetailLabelWithHelper: hasHelperLabel,
        })}
      >
        {label}{' '}
        {hasHelperLabel && (
          <Tooltip title={helperLabel} getPopupContainer={container}>
            <span>
              <IconHelp size={14} />
            </span>
          </Tooltip>
        )}
      </div>

      <div className={cx('rowDetailValueContainer')}>
        <div
          className={cx([
            'rowDetailValue',
            { [contentClassName]: !!contentClassName },
          ])}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

SingleRow.displayName = 'SingleRow';
